import React, { useReducer, Reducer } from "react";
import { RouteComponentProps } from "@reach/router";
import produce from "immer";
import { useScrollTopOnMount } from "@hooks";
import { Container, H1, Box, Text } from "@atoms";
import { BrandListContentQuery } from "../BrandListContent";
import { BrandListLetters } from "../BrandListLetters";
import { BrandListFeaturedBrands } from "../BrandListFeaturedBrands";
import { BrandListLinkTypeFilters } from "../BrandListLinkTypeFilters";
import { TReducerActions, TReducerState } from "../types";

// == Types ================================================================

// == Constants ============================================================

const FILTERS_REDUCER: Reducer<TReducerState, TReducerActions> = (state, action) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case "SET_LETTER":
        draft.filterType = "LETTER";
        draft.activeFilter = action.filter;
        break;
      case "SET_NAMED_FILTER":
        draft.filterType = "NAMED_SORT";
        draft.activeFilter = action.filter;
        break;
      case "SET_TYPE_FILTER":
        draft.linkTypeFilter = action.linkTypeFilter;
        break;
      default:
        break;
    }
  });
};

const INITIAL_STATE: TReducerState = {
  filterType: "NAMED_SORT",
  activeFilter: "POPULARITY",
  linkTypeFilter: null,
};

// == Component ============================================================

export default function BrandListView(_props: RouteComponentProps) {
  useScrollTopOnMount();
  const [state, dispatch] = useReducer(FILTERS_REDUCER, INITIAL_STATE);
  const { filterType, activeFilter, linkTypeFilter } = state;

  return (
    <>
      <Box bg="lightBg" py={[4, 4, 5]}>
        <Container textAlign="center">
          <H1 mb={2}>Brand Directory</H1>
          <Text>A full list of all of our brands</Text>
        </Container>
      </Box>
      <Container isMainContainer>
        <BrandListFeaturedBrands />
        <BrandListLetters activeFilter={activeFilter} dispatch={dispatch} />
        <BrandListLinkTypeFilters dispatch={dispatch} linkTypeFilter={linkTypeFilter} />
        <BrandListContentQuery
          activeFilter={activeFilter}
          filterType={filterType}
          linkTypeFilter={linkTypeFilter}
        />
      </Container>
    </>
  );
}

// == Styles ===============================================================
